import axios from "axios";

export const ACTIVITY_TYPE_URL = "/ActivityType";

/** Belli Bir Faaliyet Türü Listesini Elde Eder */
export function getActivityTypes(queryParams) {
  return axios.post(`${ACTIVITY_TYPE_URL}/GetActivityTypes`, queryParams);
}

/** Belli Bir Faaliyet Türü Listesini Sayfalama Olmadan Elde Eder */
export function getAllActivityTypes(queryParams) {
  return axios.post(`${ACTIVITY_TYPE_URL}/GetAllActivityTypes`, queryParams);
}

/** Yeni Bir Faaliyet Türü Elde Eder */
export function getNewActivityType() {
  return axios.get(ACTIVITY_TYPE_URL);
}

/** Belli Bir Faaliyet Türünü Elde Eder */
export function getActivityType(id) {
  return axios.get(`${ACTIVITY_TYPE_URL}/${id}`);
}

/** Belli Bir Faaliyet Türünü Kaydeder */
export function saveActivityType(activityType) {
  return axios.post(ACTIVITY_TYPE_URL, activityType);
}

/** Belli Bir Faaliyet Türü Listesini Siler */
export function deleteActivityTypes(ids) {
  return axios.post(`${ACTIVITY_TYPE_URL}/Delete`, ids);
}